import { createApp } from 'vue'
import { createHead } from '@vueuse/head'
import App from './App.vue'
import router from './router'
import VueSilentbox from 'vue-silentbox'
import 'bootstrap/dist/css/bootstrap.min.css'
import 'vue-silentbox/dist/style.css'

const app = createApp(App);
const head = createHead();
app.use(router);
app.use(head);
app.use(VueSilentbox);
app.mount('#app');
